import React from "react";
import { Layout } from "../../layouts/Layout";

const QualityPolicy = () => {
  return (
    <Layout footer = {2} breadcrumb={"Quality Policy"} title={"Quality Policy"}>
      <br/>

      <h2 style = {{paddingBlockStart:'20px'}}>TRIO Management Consultant's Quality Policy</h2>

      <br/>
      <p>
      We are committed to provide specialized and customized management consulting services, 
      generated each time according to the needs and expectation of individual customers.
      <br/>
      We will render our services with a level of response, service, ethical and care that 
      delivers complete satisfaction in all respects.

      </p>
      <br/>
         </Layout>
  );
};

export default QualityPolicy;
